var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.7,21.7l14.4-4.2c0.9-0.3,1.6,0.5,1.4,1.4l-4.2,14.4c-0.3,1-1.6,1.1-2.1,0.2l-2-4c0-0.1-0.1-0.2-0.2-0.3 l-6.2,6.2c-0.9,0.9-2.3,0.9-3.2,0s-0.9-2.3,0-3.2L6.8,26c-0.1-0.1-0.2-0.1-0.3-0.2l-4-2C1.7,23.3,1.8,22,2.7,21.7z M18,31.5 c7.5,0,13.5-6,13.5-13.5S25.5,4.5,18,4.5S4.5,10.5,4.5,18c0,0.3,0,0.5,0,0.8l-4.4,1.3C0,19.4,0,18.7,0,18C0,8.1,8.1,0,18,0 s18,8.1,18,18s-8.1,18-18,18c-0.7,0-1.4,0-2.1-0.1l1.3-4.4C17.5,31.5,17.7,31.5,18,31.5z M18.2,28.1l1.4-4.7 c2.4-0.7,4.1-2.8,4.1-5.4c0-3.1-2.5-5.6-5.6-5.6c-2.6,0-4.7,1.7-5.4,4.1l-4.7,1.4c0.1-5.5,4.6-10,10.1-10c5.6,0,10.1,4.5,10.1,10.1 C28.1,23.5,23.7,28,18.2,28.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsWhite);
export default __webpack_public_path__ + "static/media/Analytics_White.3397b5c21fb543e551b74f99b4ada05e.svg";
export { ForwardRef as ReactComponent };